import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../contexts/EncoreContext";
import { Experimental__IconCheckAlt } from "../../Experimental__Icon/icons/Experimental__IconCheckAlt";
import { Icon } from "../";
export function IconCheckAlt(props) {
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);

  if (status !== encoreContextStatus.deprecated) {
    return /*#__PURE__*/React.createElement(Experimental__IconCheckAlt, props);
  }

  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    dangerouslySetInnerHTML: {
      __html: "<rect width=\"24\" height=\"24\" fill=\"none\"/><circle cx=\"12\" cy=\"12\" r=\"9.5\" fill=\"none\" stroke=\"#181818\"/><polyline points=\"6.66 12 10.43 16.41 17.32 8.34\" fill=\"none\" stroke=\"#181818\"/>"
    }
  }));
}
export default IconCheckAlt;